// removed by extract-text-webpack-plugin
module.exports = {"root":"common__root-JRV2E"};